function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_11",
  "data-name": "Group 11",
  transform: "translate(-20 -20)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Stroke_1",
  "data-name": "Stroke 1",
  d: "M2.373,0S0,8.026,0,13.736c0,7.621,6.238,9.925,9.732,9.925s9.733-2.3,9.733-9.925C19.465,8.026,17.091,0,17.091,0Z",
  transform: "translate(21 21)",
  fill: "none",
  stroke: "#391d4d",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Stroke_3",
  "data-name": "Stroke 3",
  d: "M.25,0V19.706",
  transform: "translate(31 45)",
  fill: "none",
  stroke: "#391d4d",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Stroke_5",
  "data-name": "Stroke 5",
  d: "M13.9.25H0",
  transform: "translate(24 65)",
  fill: "none",
  stroke: "#391d4d",
  strokeMiterlimit: 10,
  strokeWidth: 2
}));

var SvgIconWineStill = function SvgIconWineStill(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.464,
    height: 46.25,
    viewBox: "0 0 21.464 46.25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconWineStill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-wine-still.f876d8ab.svg";
export { ForwardRef as ReactComponent };